import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';

Component('tr-repository-members-form', {
  mixins: [eventListenerMixin],

  ready() {
    window.tower.initManageMembers($(this), true);
  },

  disconnected() {
    this.stopListening();
  },
});
